import PropTypes from 'prop-types';
import React from 'react';
import LetterButton from './LetterButton';

export default class LetterButtonGrid extends React.Component {
    buttonMap(text, index) {
        const item = text.toLowerCase();

        return (
            <LetterButton
                text={text}
                key={index}
                isSelected={(item === this.props.selectedIndex)}
                isEnabled={this.props.isEnabled
                    || this.props.enabledButtons.includes(item)}
                onButtonClick={() => this.props.onButtonClick(item)}
                isDisabled={this.props.isDisabled}
            />
        );
    }

    render() {
        return (
            <div className="letter-button-grid">
                { this.props.buttons.map(this.buttonMap, this) }
            </div>
        );
    }
}

LetterButtonGrid.propTypes = {
    onButtonClick: PropTypes.func.isRequired,
    buttons: PropTypes.array.isRequired,
    selectedIndex: PropTypes.string,
    enabledButtons: PropTypes.array,
    isEnabled: PropTypes.bool,
    isDisabled: PropTypes.bool,
};

LetterButtonGrid.defaultProps = {
    selectedIndex: undefined,
    enabledButtons: [],
    isEnabled: true,
    isDisabled: false,
};
